import React, { useEffect, useState, useRef } from "react";
import "./roiSection.css";
import line from "../../images/line.svg";
import NumberDisplay from "../NumberDisplay";
import ScrollReveal from "../scrollReveal/scrollReveal";

export default function ROI() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const sectionNode = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionNode) {
      observer.observe(sectionNode);
    }
    return () => {
      if (sectionNode) {
        observer.unobserve(sectionNode);
      }
    };
  }, []);

  return (
    <ScrollReveal>
      <section className="roi-section" ref={sectionRef}>
        <div className="container">
          <div className="section-wrapper">
            <div className="section-heading">
              <div className="heading-description">
                <h2>AgentRAI ROI</h2>
              </div>
            </div>
            <div className="roi-content-wrapper">
              <div className="roi-card efficiency">
                <NumberDisplay
                  first={13}
                  last={28}
                  char="%"
                  isVisible={isVisible}
                />
                <h3>
                  Increase in operational efficiency by streamlining risk
                  management and compliance processes.
                </h3>
              </div>
              <img className="divider" src={line} alt="line" />
              <div className="roi-card reduction">
                <NumberDisplay
                  first={20}
                  last={35}
                  char="%"
                  isVisible={isVisible}
                />
                <h3>
                  Improvement in AI performance consistency through enhanced
                  quality assurance and operational guardrails.
                </h3>
              </div>
              <img className="divider" src={line} alt="line" />
              <div className="roi-card timely-resolution">
                <NumberDisplay
                  first={30}
                  last={45}
                  char="%"
                  isVisible={isVisible}
                />
                <h3>
                  Reduction in risk-related incidents with AI trust score
                  integration and proactive guardrails.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}
